import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LoginPage } from './pages/Login.js';
import { RegisterPage } from './pages/Register.js';
import { HomePage } from './pages/Home.js';
import { ActiveTripPage } from './pages/ActiveTrip.js';
import { HistoryPage } from './pages/History.js';
import { AccountPage } from './pages/Account.js';
import { useSession } from './state/session.js';
import { useActiveTrip } from './state/activeTrip.js';
import { IS_DEMO } from './demo/config.js';

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = useSession((s) => s.accessToken);
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

export function App() {
  const tripId = useActiveTrip((s) => s.tripId);
  const location = useLocation();

  // If the rider has an active trip but lands on Home, send them back to the trip view.
  useEffect(() => {
    if (tripId && location.pathname === '/') {
      window.history.replaceState({}, '', '/trip');
    }
  }, [tripId, location.pathname]);

  return (
    <Routes>
      <Route path="/login" element={IS_DEMO ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/register" element={IS_DEMO ? <Navigate to="/" replace /> : <RegisterPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            {tripId ? <ActiveTripPage /> : <HomePage />}
          </RequireAuth>
        }
      />
      <Route
        path="/trip"
        element={
          <RequireAuth>
            <ActiveTripPage />
          </RequireAuth>
        }
      />
      <Route
        path="/trips"
        element={
          <RequireAuth>
            <HistoryPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
